/**
 * Executes the first call immediately and executes the last call after a period of inactivity
 * (i.e. no calls to this method) defined by the timeout parameter.
 */
export default function debounce(fn, timeout = 300) {
  let debounceTimeout = null;
  return function debouncedFn(...args) {
    const isDebouncing = !!debounceTimeout;
    clearTimeout(debounceTimeout);
    if (!isDebouncing) {
      fn(...args);
    }
    debounceTimeout = setTimeout(() => {
      debounceTimeout = null;
      if (isDebouncing) {
        fn(...args);
      }
    }, timeout);
  };
}
